import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import { Menu } from "@mui/material";
import React from "react";

import { ConfirmationDialog } from "@/components/molecules/ConfirmationDialog";
import SWR_KEYS from "@/constants/swr-keys";
import useRemoveAddress from "@/hooks/requests/contact/AdditionalContactAddresses/use-remove-address";
import useDialog from "@/hooks/use-dialog";
import useMutate from "@/hooks/use-mutate";
import IContact, { IAddress } from "@/interfaces/contact.interface";
import { ContactInfoMessages } from "@/messages/contacts/contact-Info.messages";
import NotificationItem from "@/mui/Items/NotificationItem";

import AddressDialog from "../AdressDialog";

interface Props {
  isOpen: boolean;
  anchorEl: (EventTarget & HTMLButtonElement) | null;
  onClose: () => void;
  messages: ContactInfoMessages;
  selected: IAddress;
  contact: IContact | null;
}

export function AddressPopover({ isOpen, anchorEl, onClose, messages, selected, contact }: Props) {
  const { remove, isLoading: isLoadingRemoveAddress } = useRemoveAddress();
  const { mutate } = useMutate();

  const _id = selected.id;

  const {
    isVisible: isDeleteDialogVisible,
    handleOpen: handleOpenDeleteDialog,
    handleClose: handleCloseDeleteDialog,
  } = useDialog<IAddress>();

  const {
    isVisible: isEditDialogVisible,
    handleOpen: handleOpenEditDialog,
    handleClose: handleCloseEditDialog,
  } = useDialog<IAddress>();

  const onSuccess = () => {
    mutate(SWR_KEYS.getContactById);
    onClose();
    handleCloseDeleteDialog();
  };

  const handleCloseAddressDialog = () => {
    onClose();
    handleCloseEditDialog();
  };

  const handleConfirmDelete = async () => {
    const successMessage = messages.deleteAddressSuccess;

    await remove({ _id, onSuccess, successMessage });
  };

  return (
    <Menu
      open={isOpen}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "left",
      }}
    >
      <NotificationItem
        icon={<EditIcon />}
        onClick={() => {
          handleOpenEditDialog();
        }}
        title={messages.updatePopover}
      />

      <NotificationItem
        icon={<DeleteIcon />}
        title={messages.removePopover}
        onClick={() => handleOpenDeleteDialog()}
      />

      <ConfirmationDialog
        isOpen={isDeleteDialogVisible}
        onClose={handleCloseDeleteDialog}
        onConfirm={() => handleConfirmDelete()}
        titleText={messages.deleteAddressDialogTitle}
        descriptionText={messages.deleteAddressDialogContent}
        cancelText={messages.deleteAddressDialogCancel}
        isLoading={isLoadingRemoveAddress}
        confirmText={messages.deleteAddressDialogConfirm}
      />

      <AddressDialog
        isOpen={isEditDialogVisible}
        onClose={handleCloseAddressDialog}
        contact={contact}
        address={selected}
        messages={messages}
        isEditing
      />
    </Menu>
  );
}
